
import Vue from "vue";
import VButton from "@/components/common/button.vue";
import { mapGetters } from "vuex";

export default Vue.extend({
  name: "component-filter-header",
  components: { VButton },
  props: {
    hideAreaBar: Boolean,
  },
  computed: {
    ...mapGetters("ui", ["isMobile"]),
    showTitle(): string {
      return this.hideAreaBar
        ? (this.$i18n.t("Nav.placeCateogory") as string)
        : (this.$i18n.t("Filter.title") as string);
    },
  },

  mounted() {
    const btn = (this.$refs.CloseBtn as Vue & Element).$el as HTMLElement;
    btn?.focus();
  },

  methods: {
    closeClicked() {
      this.$emit("close-filter");
    },
  },
});
